"use client"

import {useEffect, useState} from "react";
import {GoogleAuthenticationTab} from "./GoogleAuthenticationTab/GoogleAuthenticationTab";
import {Office365Tab} from "./Office365AuthenticationTab/Office365Tab";
import {AppearanceTab} from "./AppearanceTab/AppearanceTab";
import {TopLinksTab} from "./TopLinksTab/TopLinksTab";
import {LanguageSettingsTab} from "./LanguageSettingsTab";
import {SocialSettingsTab} from "./SocialSettingsTab";
import {TechSupportSettings} from "./TechSupportSettings";
import {AnalyticsSettings} from "./AnalyticsSettings";
import {SisSyncTab} from "./SisSyncTab";
import {useStores} from "../../stores/useStores";
import {useTranslateClassName} from "../../hooks/useTranslateClassName";
import classNames from "classnames";

type ITab =
    "#appearance-tab"
    | "#google-auth-tab"
    | "#office365-auth-tab"
    | "#social-tab"
    | "#tech-support-tab"
    | "#top-links-tab"
    | "#language-tab"
    | "#analytics-tab"
    | "#sis-tab"

const components = {
    "#appearance-tab": AppearanceTab,
    "#google-auth-tab": GoogleAuthenticationTab,
    "#office365-auth-tab": Office365Tab,
    "#social-tab": SocialSettingsTab,
    "#tech-support-tab": TechSupportSettings,
    "#top-links-tab": TopLinksTab,
    "#language-tab": LanguageSettingsTab,
    "#analytics-tab": AnalyticsSettings,
    '#sis-tab': SisSyncTab,
}

export default function OrganizationSettings() {
    const [activeTab, setActiveTab] = useState<ITab>("#appearance-tab");
    const {organizationStore} = useStores();
    const translateClassName = useTranslateClassName();
    const isTopLevelOrg = organizationStore.currentOrganization.parent_id === "root";
    const identityProvider = organizationStore.organization.json_data.settings.identity.provider;

    const ContentComponent = components[activeTab];

    useEffect(() => {
        if (window.location.hash !== '' && components[window.location.hash]) {
            setActiveTab(window.location.hash as ITab);
        }
    }, []);

    return <div id="sb-main-content" className={classNames("sb-settings-container", "sb-content-width", translateClassName)}>
        <div className="sb-settings-block-bootstrap">
            <div className="col-sm-2 sb-settings-block-navigation">
                <ul className="nav admin-nav nav-pills nav-stacked" role="tablist">
                    <li role="presentation" className={`nav-li ${activeTab === "#appearance-tab" ? "active" : ""}`}>
                        <a href="#appearance-tab"
                           onClick={() => setActiveTab("#appearance-tab")}
                           aria-controls="profile" role="tab">Appearance</a>
                    </li>
                    {isTopLevelOrg && <>
                        <li role="presentation"
                            className={`nav-li ${activeTab === "#sis-tab" ? "active" : ""}`}>
                            <a href="#sis-tab"
                               onClick={() => setActiveTab("#sis-tab")}
                               aria-controls="profile" role="tab">SIS Roster Sync</a>
                        </li>
                        <li role="presentation"
                            className={`nav-li ${activeTab === "#google-auth-tab" ? "active" : ""}`}>
                            <a href="#google-auth-tab"
                               onClick={() => setActiveTab("#google-auth-tab")}
                               aria-controls="profile" role="tab">
                                Authenticate with Google</a>
                        </li>
                        <li role="presentation"
                            className={`nav-li ${activeTab === "#office365-auth-tab" ? "active" : ""}`}>
                            <a href="#office365-auth-tab"
                               onClick={() => setActiveTab("#office365-auth-tab")}
                               aria-controls="profile"
                               role="tab">
                                Authenticate with Office 365
                            </a>
                        </li>
                    </>}
                    <li role="presentation" className={`nav-li ${activeTab === "#social-tab" ? "active" : ""}`}>
                        <a href="#social-tab"
                           onClick={() => setActiveTab("#social-tab")}
                           aria-controls="profile" role="tab">
                            Social Networks
                        </a>
                    </li>
                    {isTopLevelOrg && <li role="presentation"
                                          className={`nav-li ${activeTab === "#tech-support-tab" ? "active" : ""}`}>
                        <a href="#tech-support-tab"
                           onClick={() => setActiveTab("#tech-support-tab")}
                           aria-controls="profile" role="tab">
                            Technical Support Widget</a>
                    </li>}
                    <li role="presentation" className={`nav-li ${activeTab === "#top-links-tab" ? "active" : ""}`}>
                        <a href="#top-links-tab"
                           onClick={() => setActiveTab("#top-links-tab")}
                           aria-controls="profile" role="tab">
                            Top Links
                        </a>
                    </li>
                    <li role="presentation" className={`nav-li ${activeTab === "#language-tab" ? "active" : ""}`}>
                        <a href="#language-tab"
                           onClick={() => setActiveTab("#language-tab")}
                           aria-controls="profile" role="tab">
                            Language
                        </a>
                    </li>
                    <li role="presentation" className={`nav-li ${activeTab === "#analytics-tab" ? "active" : ""}`}>
                        <a href="#analytics-tab"
                           onClick={() => setActiveTab("#analytics-tab")}
                           aria-controls="profile" role="tab">
                            Analytics
                        </a>
                    </li>
                </ul>
            </div>
            <div id="district-settings-content" className="col-sm-10 sb-settings-block-content">
                <div className="tab-content">
                    <ContentComponent currentIdP={identityProvider}/>
                </div>
            </div>
        </div>
    </div>
}
